import { useContext } from 'react';
import { OfferCardContext } from '@/contexts/offerCard.context';
export function useOfferCard() {
    return useContext(OfferCardContext);
}
